import React from 'react';
import { Form, Errors } from '/src/components';
import { getCookie, removeCookie } from '/src/utils';
import { cloudflareGetRecaptchaToken, cloudflareUseRecaptcha } from '/src/services';
import { VIP } from '/src/consts';
import * as styles from './styles.scss';

const Login = ({
    login,
    hideModal,
    isLoading,
    translate,
    cloudflareSiteKey,
    data,
    errors,
    setErrors,
    fieldsErrors,
    handleChange,
    validateData,
    handleOtp,
    requestPasswordOtp,
    setFormValues,
})  => {
    const { cloudflareResetRecaptcha } = cloudflareUseRecaptcha(cloudflareSiteKey, '#cf-turnstile');

    const handleSubmitLogin = e => {
        e.preventDefault();
        const isValidData = validateData();
        const isVip = getCookie(VIP);
        const loginData = isVip ? { ...data, vip_status: true } : data;

        const recaptchaToken = cloudflareGetRecaptchaToken();

        if (!recaptchaToken) {
            setErrors([{ message: 'Check recaptcha' }]);
        } else if (isValidData) {
            login(loginData, { 'cf-turnstile-response': recaptchaToken })
                .then(() => {
                    removeCookie(VIP);
                    hideModal();
                }).catch(errors => {
                    cloudflareResetRecaptcha();
                    setErrors(errors);
                });
        }
    };

    const handleMoveToOtp = () => {
        const recaptchaToken = cloudflareGetRecaptchaToken();

        if (!recaptchaToken) {
            setErrors([{ message: 'Check recaptcha' }]);
        } if (!data.email) {
            setFormValues({ fieldsErrors: { email: 'Is required' }})
        } else {
            requestPasswordOtp({ email: data.email }, { 'cf-turnstile-response': recaptchaToken }).then(() => {
                handleOtp();
            }).catch(() => {
                handleOtp();
            });
        }
    };

    return (
        <>
            <Errors errors={errors} translate={translate} />
            <Form onSubmit={handleSubmitLogin}>
                <Form.Column mb>
                    <Form.Input
                        placeholder={translate('Enter your email')}
                        label={translate('Email')}
                        type="email"
                        name="email"
                        value={data.email}
                        onChange={handleChange}
                        error={translate(fieldsErrors.email)}
                    />
                </Form.Column>
                <Form.Column mb>
                    <Form.InputPassword
                        placeholder={translate('Enter your password')}
                        label={translate('Password')}
                        name="password"
                        value={data.password}
                        onChange={handleChange}
                        error={translate(fieldsErrors.password)}
                        autoComplete="current-password"
                    />
                </Form.Column>
                <div id="cf-turnstile" />
                <div className={styles.otp}>
                    {translate('Or login with a')}
                    <button
                        type="button"
                        onClick={handleMoveToOtp}
                    >
                        {translate('One time password (OTP)')}
                    </button>
                </div>
                <Form.Column mt>
                    <Form.Button disabled={isLoading}>
                        {translate('Submit')}
                    </Form.Button>
                </Form.Column>
            </Form>
        </>
    );
};

export default Login;
